import { mdiCogOutline, mdiEyeOffOutline, mdiEyeOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { routes } from "constants/routes";
import { formatNumber } from "helpers/formatNumber";
import useDeviceType from "hooks/useDeviceType";
import { IWalletBalance } from "models/Home";
import { useSelector } from "react-redux";
import { selectWalletBalance } from "store/home/selector";
import styles from "./style.module.scss";

interface IProps {
  data: IWalletBalance;
}

export default function HomeWalletStatusCard({ data }: Readonly<IProps>) {
  const navigate = useNavigate();
  const walletBalance = useSelector(selectWalletBalance);
  const [isShowBalance, setIsShowBalance] = useState(true);
  const { isDesktop } = useDeviceType();

  const goToSettings = () => {
    navigate(routes.HOME_CARD_SETTINGS);
  };

  const goToWallet = () => {
    navigate(routes.HAULPAY_BROKER_WALLET);
  };

  return walletBalance ? (
    <div className={styles.walletStatusCard}>
      <div className={styles.section}>
        <span className="text-lg">{data.title}</span>
        {data.showButton && (
          <div className={styles.buttonGroup}>
            <button onClick={() => setIsShowBalance(!isShowBalance)}>
              {isShowBalance ? <Icon path={mdiEyeOffOutline} /> : <Icon path={mdiEyeOutline} />}
            </button>
            {!isDesktop ? (
              <button onClick={goToSettings}>
                <Icon path={mdiCogOutline} className="size-7" />
              </button>
            ) : null}
          </div>
        )}
      </div>

      <div className={styles.section}>
        <div className={styles.balance}>
          <span>{isShowBalance ? formatNumber(walletBalance[data.value] ?? 0, 2) : "$***.**"}</span>
        </div>
        <button className={styles.viewDetailsBackground} onClick={goToWallet}>
          <span className={styles.viewDetailsButton}>VIEW DETAILS</span>
        </button>
      </div>
    </div>
  ) : null;
}
